import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest'
import { ClientsWithRemainingMoney } from '../../Models/Trainee';
import { InterActive } from '../../utilities/ViewModelStructure'
import { Notify } from '../../Handlers/Notifications';
export class ClientsWithRemainingMoneyVM extends InterActive{
    private data:ClientsWithRemainingMoney[] =[] ;
    public get Data():ClientsWithRemainingMoney[]{ return this.data  }
    public set Data(value:ClientsWithRemainingMoney[]){ this.data = value ; this.update()  }

    private finished:boolean = false;
    public get Finished():boolean{ return this.finished  }
    public set Finished(value:boolean){ this.finished = value ; this.update()  }

    private search:string = '';
    public get Search():string{ return this.search  }
    public set Search(value:string){ this.search = value ; this.update()  }


    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.clientsWithRemainingMoney('0' , this.search)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data]
                                this.finished = false
                                this.update()
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    
    public async getMore(){
        if(!this.finished){
            if(this.data.length>0){
                try{
                    const response = await ApiRequest.clientsWithRemainingMoney(this.data[this.data.length-1].id, this.search)
                    console.log(response)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length>0){
                                    this.data = [...this.data,...response.data.data]
                                    this.finished=false
                                    this.update()
                                }
                                else {
                                    this.finished = true
                                    this.update()
                                }
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        }
        
    }
}